import axios from 'axios';

export async function getFinanceForms() {
	const { data } = await axios.get('/care_quest_groups', {
		params: {
			filter: JSON.stringify({
				where: {
					name: { inq: ['Monthly Income Form', 'Monthly Expense Form'] },
				},
				include: [
					{
						relation: 'care_quest_group_questions',
						scope: {
							order: ['question_order'],
						},
					},
				],
				order: 'name DESC',
			}),
		},
	});
	return data;
}

export async function getLastResponses(groupIds, clientId) {
	const responses = [];
	const { data: incomeData } = await axios.get(
		`/clients/${clientId}/care_quest_response_groups`,
		{
			params: {
				filter: JSON.stringify({
					where: {
						care_quest_groupId: groupIds[0],
					},
					include: 'care_quest_responses',
					limit: 1,
					order: 'response_dttm DESC',
				}),
			},
		},
	);
	if (Array.isArray(incomeData) && incomeData.length > 0) {
		responses.push(incomeData[0]);
	}

	const { data: expenseData } = await axios.get(
		`/clients/${clientId}/care_quest_response_groups`,
		{
			params: {
				filter: JSON.stringify({
					where: {
						care_quest_groupId: groupIds[1],
					},
					include: 'care_quest_responses',
					limit: 1,
					order: 'response_dttm DESC',
				}),
			},
		},
	);
	if (Array.isArray(expenseData) && expenseData.length > 0) {
		responses.push(expenseData[0]);
	}

	return responses;
}

export async function saveFinanceValues({
	userId,
	care_quest_groupId,
	questions,
	answers,
}) {
	const { data } = await axios.post(
		`/clients/${userId}/care_quest_response_groups`,
		{
			care_quest_groupId,
			response_dttm: new Date(),
			completed_by_type: 'client',
			completed_by_id: userId,
		},
	);
	await Promise.all(
		questions.map((question, index) =>
			axios.post(`/clients/${userId}/care_quest_responses`, {
				clientId: userId,
				care_quest_response_groupId: data.id,
				care_quest_questionId: question.id,
				care_quest_groupId,
				response_dttm: new Date(),
				care_quest_answer_text:
					Array.isArray(answers) && answers[index]
						? answers[index]
						: question.default_answer,
			}),
		),
	);
}
